module.exports = __webpack_public_path__ + "img/id9.c36ab56d.png";